import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: "/img/banner1.jpg",
      subtitle: "Go Live, Be Seen, Get Famous!",
      title: "Broadcast Your Talent to the World in Real-Time",
      description: "MastiShorts lets you go live instantly and connect with thousands of viewers. Whether you're a performer, gamer, or entertainer, your audience is just a tap away!"
    },
    {
      image: "/img/banner2.png", 
      subtitle: "Create. Stream. Shine.",
      title: "Short Videos + Live Streaming = Double the Fun",
      description: "Capture moments, create fun short videos, or go live — all from your Android device. MastiShorts is your creative stage on the go."
    },
    {
      image: "/img/banner1.jpg",
      subtitle: "India's Hottest New Live Streaming App", 
      title: "Made for Real-Time Fame, Built for Creators",
      description: "Join a growing community of creators and streamers on MastiShorts. Showcase your talent, interact live, and grow your fanbase in style."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="header-carousel position-relative overflow-hidden">
      {slides.map((slide, index) => (
        <div 
          key={index}
          className={`header-carousel-item position-absolute top-0 start-0 w-100 h-100 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ 
            minHeight: '100vh',
            transition: 'opacity 1s ease-in-out',
            zIndex: index === currentSlide ? 2 : 1
          }}
        >
          {/* Background Image */}
          <div 
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          ></div>
          
          {/* Overlay */}
          <div 
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)'
            }}
          ></div>
          
          {/* Content */}
          <div className="carousel-caption h-100 d-flex align-items-center">
            <div className="container py-4">
              <div className="row g-5 align-items-center">
                <div className="col-xl-7">
                  <div className="text-start">
                    <h4 
                      className="text-warning text-uppercase fw-bold mb-4"
                      style={{
                        animation: index === currentSlide ? 'fadeInLeft 1s ease-out 0.5s both' : 'none'
                      }}
                    >
                      {slide.subtitle}
                    </h4>
                    <h1 
                      className="display-4 text-uppercase text-white mb-4"
                      style={{
                        animation: index === currentSlide ? 'fadeInLeft 1s ease-out 0.7s both' : 'none'
                      }}
                    >
                      {slide.title}
                    </h1>
                    <p 
                      className="mb-4 fs-5 text-light"
                      style={{
                        animation: index === currentSlide ? 'fadeInLeft 1s ease-out 0.9s both' : 'none'
                      }}
                    >
                      {slide.description}
                    </p>
                    <div 
                      className="d-flex flex-shrink-0"
                      style={{
                        animation: index === currentSlide ? 'fadeInLeft 1s ease-out 1.1s both' : 'none'
                      }}
                    >
                      <a 
                        className="btn btn-primary rounded-pill text-white py-3 px-5 shadow-lg me-3" 
                        href="/user" 
                        target='_blank'
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-google-play me-2"></i>
                        Go to Panel
                      </a>
                      <a 
                        className="btn btn-primary rounded-pill text-white py-3 px-5 shadow-lg me-3" 
                        href="https://play.google.com/store/apps/details?id=com.mastiindia&pcampaignid=web_share" 
                        target='_blank'
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-google-play me-2"></i>
                        Download Now
                      </a>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 d-none d-xl-block">
                  <div 
                    className="text-center"
                    style={{
                      animation: index === currentSlide ? 'fadeInRight 1s ease-out 1s both' : 'none'
                    }}
                  >
                    {/* Floating Phone Mockup */}
                    <div className="position-relative mx-auto" style={{width: '300px', height: '500px'}}>
                      <div 
                        className="bg-white rounded-4 shadow-lg p-1 h-100"
                        style={{
                          animation: 'float 3s ease-in-out infinite'
                        }}
                      >
                        <div className="bg-dark rounded-4 h-100 d-flex align-items-center justify-content-center position-relative overflow-hidden">
                          {/* App Interface */}
                          <div className="text-center text-white">
                            <i className="fas fa-video fa-4x mb-3 text-primary"></i>
                            <h5 className="mb-2">MastiShorts</h5>
                            <p className="small opacity-75 mb-3">Go Live Now</p>
                            <div className="d-flex justify-content-center gap-2">
                              <div className="bg-primary rounded-circle" style={{width: '8px', height: '8px'}}></div>
                              <div className="bg-light bg-opacity-25 rounded-circle" style={{width: '8px', height: '8px'}}></div>
                              <div className="bg-light bg-opacity-25 rounded-circle" style={{width: '8px', height: '8px'}}></div>
                            </div>
                          </div>
                          
                          {/* Floating Elements */}
                          <div className="position-absolute top-0 start-0 w-100 h-100">
                            <div 
                              className="position-absolute bg-primary rounded-circle opacity-20" 
                              style={{
                                width: '60px', 
                                height: '60px', 
                                top: '15%', 
                                left: '10%',
                                animation: 'pulse 2s infinite'
                              }}
                            ></div>
                            <div 
                              className="position-absolute bg-warning rounded-circle opacity-20" 
                              style={{
                                width: '40px', 
                                height: '40px', 
                                bottom: '20%', 
                                right: '15%',
                                animation: 'pulse 2s infinite 1s'
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Floating Badges */}
                      <div 
                        className="position-absolute bg-success text-white px-2 py-1 rounded-pill small shadow-sm"
                        style={{
                          top: '10%',
                          left: '-10%',
                          animation: 'bounce 2s infinite'
                        }}
                      >
                        <i className="fas fa-heart me-1"></i>Live
                      </div>
                      <div 
                        className="position-absolute bg-warning text-dark px-2 py-1 rounded-pill small shadow-sm"
                        style={{
                          bottom: '15%',
                          right: '-15%',
                          animation: 'bounce 2s infinite 0.5s'
                        }}
                      >
                        <i className="fas fa-gift me-1"></i>Gifts
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      {/* Carousel Indicators */}
      <div className="position-absolute bottom-0 start-50 translate-middle-x mb-4" style={{zIndex: 10}}>
        <div className="d-flex gap-2 mb-3">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`btn rounded-circle p-0 ${index === currentSlide ? 'btn-primary' : 'btn-outline-light'}`}
              style={{width: '12px', height: '12px'}}
              onClick={() => setCurrentSlide(index)}
            ></button>
          ))}
        </div>
        <div className="text-center text-white opacity-75">
          <small className="d-block mb-2">Scroll to explore</small>
          <i className="fas fa-chevron-down fa-lg" style={{animation: 'bounce 2s infinite'}}></i>
        </div>
      </div>
      
      <style>{`
        @keyframes fadeInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.2; }
          50% { transform: scale(1.1); opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default Hero;
